import React, {Component} from "react";
import {NoteIcon} from "../../../../common/icons";
import {Input} from "antd";
import {inject} from "mobx-react";

@inject('translationsStore')
class NoteInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      note: props.value
    };
  }

  render() {
    return (
      <Input
        className="NoteInput"
        maxLength={50}
        placeholder={this.props.translationsStore.translate('tripsList.detail.note')}
        prefix={<NoteIcon />}
        onChange={(event) => this.setState({note: event.target.value})}
        onBlur={() => this.props.onChange(this.state.note)}
        value={this.state.note}
      />
    )
  }
}
export default NoteInput;



// WEBPACK FOOTER //
// ./src/components/App/Trips/TripItem/NoteInput.js